import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { useDispatch, useSelector } from "react-redux";
import { listAllFrameSizes, updateFrameSize, deleteFrameSize, createFrameSize } from "../../redux/actions/frameSizeAction";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import Table from "../../components/Table";
import { frameSizeSchema } from "../../helper/yup.schema";
import { ButtonWrapper, FormInputLabel, Head24Tag, MainPadding, Para14Tag } from "../../assets/css/styled";
import { modelStyle } from "../../assets/css/muiStyled";
import ModalCloseButton from "../../components/modalCloseButton/ModalCloseButton";
import { Field, Form, Formik } from "formik";
import FormErrorMessage from "../../components/FormErrorMessage";
import { CheckBoxCustom } from "../../components/typography/CheckBox";

const FrameSize = () => {
  const [formInitialValues, setFormInitialValues] = useState({
    frame_size: "",
  });
  const [selectedFrameSizeTypeId, setSelectedFrameSizeTypeId] = useState(null);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [active, setActive] = useState(false);

  const dispatch = useDispatch();
  const { frameSizeList } = useSelector((state) => state.frameSize);

  useEffect(() => {
    dispatch(listAllFrameSizes());
  }, [dispatch]);

  const handleDeleteClick = (id) => () => {
    dispatch(deleteFrameSize({ id }));
  };

  const handleEditClick = (id) => () => {
    setSelectedFrameSizeTypeId(id);
    frameSizeList.forEach((x) => {
      if (x.id === id) {
        setFormInitialValues({
          frame_size: x?.frame_size,
        });
        setActive(x?.is_active);
      }
    });
    setOpen(true);
    setEdit(true);
  };

  const columns = [
    {
      field: "frame_size",
      headerName: "Frame Size",
      flex: 1,
      headerAlign: "left",
      align: "left",
      editable: true,
    },
    {
      field: "is_active",
      headerName: "Active",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: true,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleAddFrameSize = () => {
    setOpen(true);
    setEdit(false);
  };

  const handleClose = () => {
    setOpen(false);
    setActive(false);
    setFormInitialValues({
      frame_size: "",
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    try {
      const body = {
        frame_size: values?.frame_size,
        is_active: active,
      };
      if (edit) {
        dispatch(updateFrameSize(body, selectedFrameSizeTypeId));
        setOpen(false);
        setEdit(false);
        setFormInitialValues({ frame_size: "" });
        setActive(false);
        return;
      }

      // Create API
      dispatch(createFrameSize(body));
      setOpen(false);
      setActive(false);
      resetForm();
    } catch (error) {
      throw new Error(error)
    }
  };

  return (
    <MainPadding
      p_bottom={20}
      p_top={20}>
      <Box
        m="20px"
        mb={0}
        mt={0}>
        <div className="flex w-full justify-between items-center">
          <Header
            title="Frame Size"
            subtitle="View All The Frame Size"
          />
          <div className="flex justify-end">
            <ButtonWrapper
              variant="outlined"
              onClick={handleAddFrameSize}>
              Add New Frame Size
            </ButtonWrapper>
          </div>
        </div>
        <Table
          columns={columns}
          rows={frameSizeList}></Table>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={modelStyle}>
            <div className="category_modal_add_form_main_div">
              <div className="payment_model_inner_head_main">
                <Head24Tag
                  color="#0E1213"
                  weight="600">
                  {`${edit ? "Update" : "Add"} Frame Size`}
                </Head24Tag>
              </div>
              <div
                className="network_insurance_modal_close"
                onClick={handleClose}>
                <ModalCloseButton />
              </div>
            </div>

            <div className="category_add_frame_form">
              <Formik
                initialValues={formInitialValues}
                validationSchema={frameSizeSchema}
                onSubmit={handleSubmit}>
                {({ touched, errors }) => (
                  <Form>
                    <div className="technical_information_text_filed">
                      <div className="form_inner_input_div_main">
                        <FormInputLabel>Frame Size</FormInputLabel>
                        <div className="form_input_main">
                          <Field
                            type="text"
                            placeholder="Enter Frame Size"
                            name="frame_size"
                            className="from_input_tag"
                          />
                        </div>
                        {touched.frame_size && errors.frame_size && <FormErrorMessage errors={errors.frame_size} />}
                      </div>
                    </div>
                    {/* Active checkbox */}
                    <div className="technical_information_text_filed">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        className="form_input_forget_text_main_pass_inner mt-4">
                        <div className="form_get_update_text_data_title">
                          <div
                            style={{ cursor: "pointer" }}
                            className="add_new_add_default_address">
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}>
                              <div
                                style={{
                                  marginRight: "10px",
                                  cursor: "pointer",
                                }}
                                className="main_check_box">
                                <CheckBoxCustom
                                  id="is_active"
                                  name="is_active"
                                  checked={active}
                                  onChange={() => setActive(!active)}
                                />
                              </div>
                              <div className="label_text">
                                <Para14Tag
                                  weight={500}
                                  color="#A7ABAC">
                                  Active
                                </Para14Tag>
                              </div>
                              {touched.is_active && errors.is_active && <FormErrorMessage errors={errors.is_active} />}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form_sign_in_btn_main_inner_update">
                      <ButtonWrapper
                        type="submit"
                        auto={"auto"}>{`${edit ? "Update" : "Create"}`}</ButtonWrapper>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Box>
        </Modal>
      </Box>
    </MainPadding>
  );
};

export default FrameSize;
